import { EventCategory, EventSubCategory } from "@/types/events";
import { categoryHasSubcategories } from "@/utils/subcategoryMap";
import { z } from "zod";
const fileFieldSchema = z.object({
    id: z.number().optional(),
    file: z.instanceof(File),
    tipo: z.string().optional(),
    presignedUrl: z.string().optional(),
});
const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png", "video/mp4"];
const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
const MAX_VIDEO_SIZE = 10 * 1024 * 1024;
const validateFiles = (data, ctx) => {
    if (data.files.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["files"],
            message: "Adicione pelo menos um arquivo.",
        });
        return;
    }
    data.files.forEach((fileField, index) => {
        if (!fileField || fileField.id) {
            return;
        }
        const file = fileField.file;
        if (!ALLOWED_TYPES.includes(file.type)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["files", index],
                message: `${file.name}: formato não suportado.`,
            });
            return;
        }
        if (file.type.startsWith("image/") && file.size > MAX_IMAGE_SIZE) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["files", index],
                message: `${file.name}: imagens devem ter no máximo 5 MB.`,
            });
        }
        if (file.type.startsWith("video/") && file.size > MAX_VIDEO_SIZE) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["files", index],
                message: `${file.name}: vídeos devem ter no máximo 10 MB.`,
            });
        }
    });
};
const eventBaseSchema = z.object({
    latitude: z.string().min(1, "Latitude é obrigatória"),
    longitude: z.string().min(1, "Longitude é obrigatória"),
    files: z.array(fileFieldSchema),
});
export const patchEventFormSchema = eventBaseSchema
    .extend({
    observacao: z
        .string()
        .max(300, "Observação deve ter no máximo 300 caracteres")
        .optional(),
    cidade: z.string().min(1, "Cidade é obrigatória"),
    bairro: z.string().optional(),
})
    .superRefine(validateFiles);
export const postEventFormSchema = eventBaseSchema
    .extend({
    categoriaEvento: z.nativeEnum(EventCategory),
    subcategoriaEventos: z.array(z.nativeEnum(EventSubCategory)).default([]),
    dataEvento: z
        .string({ required_error: "Data do evento é obrigatória" })
        .min(1, "Data do evento é obrigatória"),
    horaEvento: z
        .string({ required_error: "Hora do evento é obrigatória" })
        .min(1, "Hora do evento é obrigatória")
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Hora inválida. Utilize o formato 24h (00:00 a 23:59)"),
    cidade: z.string().min(1, "Cidade é obrigatória"),
    bairro: z.string().optional(),
    observacao: z
        .string()
        .max(300, "Observação deve ter no máximo 300 caracteres")
        .optional(),
})
    .superRefine(validateFiles)
    .superRefine((data, ctx) => {
    if (categoryHasSubcategories(data.categoriaEvento) &&
        data.subcategoriaEventos.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["subcategoriaEventos"],
            message: "Selecione pelo menos uma subcategoria",
        });
    }
});
